module.exports = new __parcel__URL__("../images/ldde.cb72dd61.png").toString();